/**
 * @file serviceDashboardService.js
 * @description The Service department's control panel: pipeline counts,
 *              completion graphs, attention boxes (errors, silent machines,
 *              new requests) and the floor's work list — one call.
 *              Server: controllers/serviceDashboardController.js.
 */
import apiClient from './apiClient';

const serviceDashboardService = {
    async getDashboard() {
        return apiClient.get('/service/dashboard');
    },
    // The four attention boxes alone (Operations' Errors page reads these).
    async getErrorBoxes() {
        return apiClient.get('/service/error-boxes');
    },
    // Operations shares one error with the service team — the service panel
    // then shows "Operations raised" on that exact error.
    async raiseToService(err) {
        return apiClient.post('/service/ops-raise', err);
    },
};

export default serviceDashboardService;
